module.exports = __webpack_public_path__ + "static/media/selectioncartes.5c331279.png";